<template>
	<div class="main-box" ref="box">
		<el-container :style="{height: this.$root.height+'px'}">
			<el-header class="header">
				<el-menu :default-active="$route.path" mode="horizontal" router>
					<el-menu-item class="menu-item" index="/about">About</el-menu-item>
					<el-menu-item class="menu-item" index="/build">Build</el-menu-item>
					<el-menu-item class="menu-item" index="/">Home</el-menu-item>
				</el-menu>
			</el-header>
			<el-main>
				<router-view @snowSwitch="snowSwitch" @musicSwitch="musicSwitch" @greetSwitch="greetSwitch">
				</router-view>
			</el-main>
		</el-container>
		<audio src="../assets/main/いつも何度でも.mp3" ref="music"></audio>
		<img v-for="snow,index in snows" src="../assets/main/snow.png" :key='index' class="snow" :style="snow">
		<div ref="greet" class="greet">
			<p>{{greet}}</p>
			<!-- <img src="../assets/main/greet.png" /> -->
			<img src="../assets/main/greet_bg.png" />
			<img src="../assets/main/greet_eye.png" :style="{top: eyeY + 'px', left: eyeX + 'px'}" />
			<img src="../assets/main/greet_body.png" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Main',
		data() {
			return {
				snows: [],
				snowIndex: 0,
				snowNum: 30,
				eyeX: 0,
				eyeY: 0,
				interval: null,
				greet: '! ! !',
				isSnow: false,
				isGreet: false,
				isMusic: false
			}
		},
		methods: {
			getGreet() {
				let h = new Date().getHours();
				if (h < 5) {
					this.greet = "晚安啦~";
				} else if (h < 10) {
					this.greet = "早安呀~";
				} else if (h < 12) {
					this.greet = "早上好~";
				} else if (h < 17) {
					this.greet = "午安呀~";
				} else if (h < 22) {
					this.greet = "晚上好~";
				} else {
					this.greet = "晚安呀~";
				}
			},
			startSnow() {
				for (let i = 0; i < this.snowNum; i++) {
					this.snows.push({});
				}
				this.interval = setInterval(() => {
					this.snows.splice(this.snowIndex, 1, {
						top: this.$root.height + 'px',
						left: parseInt(this.$root.width * Math.random()) + 'px',
						width: this.snows[this.snowIndex].width,
						opacity: 0.3 + 0.2 * Math.random(),
						transitionDuration: parseInt(4 + 6 * Math.random()) + 's'
					});
					this.snowIndex = (this.snowIndex + 1) % this.snowNum;
					this.snows.splice(this.snowIndex, 1, {
						top: '-30px',
						transform: 'rotate(180deg)',
						left: parseInt(this.$root.width * Math.random()) + 'px',
						width: parseInt(10 + 20 * Math.random()) + 'px',
						opacity: 0.7 + 0.3 * Math.random(),
					});
				}, 200)
			},
			stopSnow() {
				clearInterval(this.interval);
				this.interval = null;
				this.snows = [];
			},
			snowSwitch() {
				this.isSnow = !this.isSnow;
				if (this.isSnow) {
					this.startSnow()
				} else {
					this.stopSnow();
				}
			},
			musicSwitch() {
				this.isMusic = !this.isMusic;
				if (this.isMusic) {
					this.$refs.music.play();
				} else {
					this.$refs.music.pause();
				}
			},
			greetSwitch() {
				this.isGreet = !this.isGreet;
				if (this.isGreet) {
					setTimeout(this.getGreet, 2000);
					this.$refs.greet.style.right = '0';
					this.$refs.greet.style.opacity = '1';
					window.addEventListener('mousemove', this.mouseMove)
				} else {
					this.eyeX = 0;
					this.eyeY = 0;
					this.greet = 'Zzz';
					this.$refs.greet.style.right = '-150px';
					this.$refs.greet.style.opacity = '0';
					window.removeEventListener('mousemove', this.mouseMove)
				}
			},
			mouseMove(e) {
				let greetX = this.$root.width - 50,
					greetY = this.$root.height - 200;
				let disX = e.clientX - greetX,
					disY = e.clientY - greetY;
				let div = Math.sqrt(disX * disX + disY * disY) / 5;
				this.eyeX = disX / div;
				this.eyeY = disY / div;
				console.log(123)
			}
		},
		mounted() {
			if (this.$root.width > 700) {
				this.snowSwitch();
				setTimeout(this.greetSwitch, 3000);
			}
			console.log(
				'  ♥  welcome  ♥\n\
				 __     __      __   __   \n\
				|  |    \\ \\    / /  |  | \n\
				|  |     \\ \\  / /   |  |  \n\
				|  |      \\ \\/ /    |  |   \n\
				|  |       |  |     |  |      \n\
				|  |_____  |  |     |  |_____  \n\
				|________| |__|     |________|  \n\
				'
			);
		},
		destroyed() {
			if (this.interval) {
				clearInterval(this.interval);
			}
			if (this.isGreet) {
				window.removeEventListener('mousemove', this.mouseMove)
			}
		}
	}
</script>

<style>
	.main-box {
		background-image: url(../assets/main/background.jpg);
		background-size: 100% 100%;
	}

	.header {
		padding: 0 !important;
		opacity: 0.9 !important;
	}

	.menu-item {
		float: right !important;
	}

	.snow {
		z-index: 9;
		position: fixed;
		transition: all linear;
	}

	.greet {
		position: fixed;
		width: 150px;
		height: 250px;
		bottom: 10px;
		right: -100px;
		opacity: 0;
		transition: all 2s;
	}

	.greet p {
		font-size: 120%;
		font-weight: bold;
		margin: 0px;
		position: absolute;
		left: 10px;
		top: 10px;
		transform: translate(-50%, 0) rotate(10deg);
	}

	.greet img {
		position: absolute;
		width: 100%;
	}
</style>
